module.exports = __webpack_public_path__ + "static/media/furquan.20cae2e2.jpeg";